module.exports = __webpack_public_path__ + "img/user-pro-big-v.95835a74.png";